import React from 'react';
import { Box, CardContent, Typography, Grid } from '@material-ui/core';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBoxTaped, faRefresh } from '@fortawesome/pro-regular-svg-icons';
import moment from 'moment';
import { Enrollment } from '@spike/membership-model';

interface MembershipProps {
    enrollment: Enrollment;
    classes: { [key: string]: string };
    cardIcon: string;
}

const Membership: React.FC<MembershipProps> = ({ enrollment, classes, cardIcon }) => {
    const getPaymentMethod = () => {
        if (enrollment.paymentMethod) {
            return enrollment.paymentMethod.lastDigits;
        }
        if (enrollment.paid === true && enrollment.paymentMethod === null) {
            return 'Cash/Other';
        }
        return '';
    };

    return (
        <Box
            className={clsx(classes.cardStyle)}
            style={{ marginBottom: 28 }}
        >
            <CardContent className={clsx(classes.cardContent, classes.cardWide)}>
                <Typography
                    variant="h6"
                    className={classes.cardTitle}
                >
                    Membership Details
                </Typography>
                <Grid
                    container
                    spacing={2}
                    style={{ marginTop: 10 }}
                >
                    <Grid
                        item
                        xs={6}
                        sm={4}
                        lg={3}
                    >
                        <Typography
                            variant="body2"
                            className={classes.titleLabel}
                        >
                            Type
                        </Typography>
                        <Typography variant="subtitle1">
                            <FontAwesomeIcon
                                className={classes.subscriptionTypeItemIcon}
                                icon={enrollment.membership.enrollmentType === 'package' ? faBoxTaped : faRefresh}
                            />
                            {enrollment.membership.enrollmentType === 'package' ? 'Package' : 'Subscription'}
                        </Typography>
                    </Grid>

                    {enrollment.membership.enrollmentType != 'package' && (
                        <Grid
                            item
                            xs={6}
                            sm={4}
                            lg={3}
                        >
                            <Typography
                                variant="body2"
                                className={classes.titleLabel}
                            >
                                Frequency
                            </Typography>
                            <Typography
                                variant="subtitle1"
                                className={classes.labelValue}
                            >
                                {enrollment.membership.billingFrequency}
                            </Typography>
                        </Grid>
                    )}
                    <Grid
                        item
                        xs={6}
                        sm={4}
                        lg={3}
                    >
                        <Typography
                            variant="body2"
                            className={classes.titleLabel}
                        >
                            Start Date
                        </Typography>
                        <Typography
                            variant="subtitle1"
                            className={classes.labelValue}
                        >
                            {moment(enrollment.startDate).format('MMM DD, YYYY')}
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        xs={6}
                        sm={4}
                        lg={3}
                    >
                        <Typography
                            variant="body2"
                            className={classes.titleLabel}
                        >
                            End Date
                        </Typography>
                        <Typography
                            variant="subtitle1"
                            className={classes.labelValue}
                        >
                            {moment(enrollment.endDate).isValid()
                                ? moment(enrollment.endDate).format('MMM DD, YYYY')
                                : String(enrollment.endDate)}
                        </Typography>
                    </Grid>
                    {enrollment.nextBillingDate && enrollment.membership.enrollmentType != 'package' && (
                        <Grid
                            item
                            xs={6}
                            sm={4}
                            lg={3}
                        >
                            <Typography
                                variant="body2"
                                className={classes.titleLabel}
                            >
                                Next Billing
                            </Typography>
                            <Typography
                                variant="subtitle1"
                                className={classes.labelValue}
                            >
                                {moment(enrollment.nextBillingDate).format('MMM DD, YYYY')}
                            </Typography>
                        </Grid>
                    )}
                    {getPaymentMethod() && (
                        <Grid
                            item
                            xs={6}
                            sm={4}
                            lg={3}
                        >
                            <Typography
                                variant="body2"
                                className={classes.titleLabel}
                            >
                                Payment Method
                            </Typography>
                            <Box
                                display="flex"
                                alignItems="center"
                            >
                                {enrollment.paymentMethod && (
                                    <img
                                        src={cardIcon}
                                        alt="Visa"
                                        style={{ width: 32, marginRight: 8 }}
                                    />
                                )}
                                <Typography
                                    variant="subtitle1"
                                    className={classes.labelValue}
                                >
                                    {enrollment.paymentMethod?.lastDigits || getPaymentMethod()}
                                </Typography>
                            </Box>
                        </Grid>
                    )}
                    <Grid
                        item
                        xs={6}
                        sm={4}
                        lg={3}
                    >
                        <Typography
                            variant="body2"
                            className={classes.titleLabel}
                        >
                            Total
                        </Typography>
                        <Typography
                            variant="subtitle1"
                            className={classes.labelValue}
                        >
                            ${Number(enrollment.totalAmount).toFixed(2)}
                        </Typography>
                    </Grid>
                </Grid>
            </CardContent>
        </Box>
    );
};

export default Membership;
